const About: React.FC = () => {
    return (
        <div className="About">
            <h1 className="title">About</h1>
            <p className="About-descr reg">Javascript sandbox, based on React framework, where you can implement any coding ideas by importing npm modules right inside code editor</p>
            <p className="reg About-author">author: aleksandrs jurjevs</p>
        </div>
    )
}

export default About;